import { useState } from 'react';
import type { ReactElement } from 'react';
import { NoEvents } from './common';
import { Live } from './live';
import { Upcoming } from './upcoming';

export const Pending = (): ReactElement => {
  const [noEventsLive, setNoEventsLive] = useState(false);
  const [noEventsUpcoming, setNoEventsUpcoming] = useState(false);
  const [hasFilters, setHasFlters] = useState(false);

  const handleNoEvents = (isUpcoming: boolean, hide: boolean): void => {
    if (hide) {
      if (isUpcoming) {
        setNoEventsUpcoming(true);
      } else {
        setNoEventsLive(true);
      }
    } else if (isUpcoming) {
      setNoEventsUpcoming(false);
    } else {
      setNoEventsLive(false);
    }
  };

  const handleFiltersOn = (withFiltersOn: boolean): void => {
    setHasFlters(withFiltersOn);
  };


  return (noEventsLive && noEventsUpcoming && !hasFilters) ? (
    <>
      <Live handleNoEvents={handleNoEvents} style={{ display: 'none' }} />
      <Upcoming handleNoEvents={handleNoEvents} handleFiltersOn={handleFiltersOn} style={{ display: 'none' }} />
      <NoEvents />
    </>
  ) : (
    <>
      <Live handleNoEvents={handleNoEvents} />
      <Upcoming handleNoEvents={handleNoEvents} handleFiltersOn={handleFiltersOn} />
    </>
  );
};
